export const retrainLabel = (label: string) => {
  switch (label) {
    case 'status':
      return 'ステータス'
    case 'n_products':
      return '商品数'
    case 'n_features':
      return '特徴語数'
    case 'rmse':
      return '予測誤差'
    case 'n_ratings':
      return '学習データ数'
    case 'loss':
      return '損失値'
    case 'accuracy':
      return '正解率'
    case 'n_interactions':
      return '学習データ数'
    default:
      return label
  }
}
